import {
  HomeOutlined,
  UnorderedListOutlined,
  SafetyCertificateOutlined,
  SwapOutlined,
  FileDoneOutlined,
  TableOutlined,
} from "@ant-design/icons";

export const MenuItems = [
  {
    key: "home",
    label: "Inicio",
    path: "/home",
    color: "transparent",
    isFull: true,
    isLite: true,
    icon: <HomeOutlined style={{ fontSize: 19 }} />,
  },
  {
    key: "ordenes",
    label: "Mis Órdenes",
    path: "/ordenes",
    color: "#357ABD",
    isFull: true,
    isLite: false,
    icon: <UnorderedListOutlined style={{ fontSize: 19 }} />,
  },
  {
    key: "auditorias",
    label: "Mis Auditorias",
    path: "/auditorias",
    color: "#34A853",
    isFull: true,
    isLite: false,
    icon: <SafetyCertificateOutlined style={{ fontSize: 19 }} />,
  },
  {
    key: "misreubicaciones",
    label: "Mis Reubicaciones",
    path: "/reubicaciones",
    color: "#8E44AD",
    isFull: true,
    isLite: false,
    icon: <SwapOutlined style={{ fontSize: 19 }} />,
  },
  {
    key: "auditar-sma",
    label: "Auditar SMA",
    path: "/auditar-sma",
    color: "#E67E22",
    isFull: true,
    isLite: true,
    icon: <FileDoneOutlined style={{ fontSize: 19 }} />,
  },
  {
    key: "consultar-stock",
    label: "Consultar Stock",
    path: "/consultar-stock",
    color: "#8B1E3F",
    isFull: true,
    isLite: false,
    icon: <TableOutlined style={{ fontSize: 19 }} />,
  },
];
